// src/components/EntranceLoadingOverlay.jsx
import { useState, useEffect } from "react";
import "./EntranceLoadingOverlay.css";

const EntranceLoadingOverlay = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      // Cuando la página esté completamente cargada, ocultamos el overlay
      setVisible(false);
    };

    // Si el documento ya está completo, no necesitamos esperar
    if (document.readyState === "complete") {
      setVisible(false);
    } else {
      window.addEventListener("load", handleLoad);
      // Limpiamos el listener cuando el componente se desmonte
      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

  if (!visible) return null;

  return (
    <div className="entrance-loading-overlay">
      <div className="overlay-content">
        <img
          src="/logo-working-unidos.png"  // Asegúrate de colocar la ruta correcta de tu logo
          alt="Working Unidos"
          className="entrance-logo"
        />
        <p className="loading-text">Cargando...</p>
      </div>
    </div>
  );
};

export default EntranceLoadingOverlay;